import type { CSSProperties } from "react";

import "./TextLoading.css";

interface LoadingDotsProps {
    delayMs?: number;
}

interface CustomCSSProperties extends CSSProperties {
    "--wai-text-loading-dot-delay"?: string;
}

export const LoadingDots = ({ delayMs = 120 }: LoadingDotsProps) => {
    return (
        <>
            {[1, 2, 3].map(index => (
                <span
                    key={index}
                    className="wai-text-loading-dot"
                    style={{ "--wai-text-loading-dot-delay": `${index * delayMs}ms` } as CustomCSSProperties}
                >
                    .
                </span>
            ))}
        </>
    );
};
